import { createSystem, defaultConfig, defineConfig, defineRecipe } from '@chakra-ui/react'

// Кастомизация темы Chakra UI
const headingRecipe = defineRecipe({
    variants: {
        size: {
            title: {
                fontSize: '28px',
                lineHeight: '36px',
            },
        },
    },
})

const customConfig = defineConfig({
    theme: {
        recipes: { heading: headingRecipe },
        tokens: {
            colors: {
                border: {
                    primary: { value: 'var(--border-primary)' },
                    disabled: { value: 'var(--border-disabled)' },
                    accent: { value: 'var(--extensions-border-accent)' },
                    error: { value: 'var(--extensions-border-error)' },
                    success: { value: 'var(--extensions-border-success)' },
                },
                brand: {
                    50: { value: 'var(--extensions-background-light-brand)' },
                    100: { value: 'var(--extensions-background-light-brand)' },
                    200: { value: '#c8e8a0' },
                    300: { value: '#a8d870' },
                    400: { value: '#88c840' },
                    500: { value: 'var(--background-brand)' }, // rgb(20 100 20)
                    600: { value: 'var(--background-brand-pressed)' },
                    700: { value: '#145014' },
                    800: { value: '#0f3a0f' },
                    900: { value: '#0a250a' },
                    DEFAULT: { value: 'var(--background-brand)' },
                    pressed: { value: 'var(--background-brand-pressed)' },
                    light: { value: 'var(--extensions-background-light-brand)' },
                },
                sage: {
                    50: { value: '#f6f8f7' },
                    100: { value: '#e8eeec' },
                    200: { value: '#d9e2df' },
                    300: { value: '#A3CCC6' },
                    400: { value: '#bbc9c4' },
                    500: { value: '#6DA293' },
                    600: { value: '#6f8781' },
                    700: { value: '#5d736d' },
                    800: { value: '#4b5d58' },
                    900: { value: '#394743' },
                    DEFAULT: { value: '#7f9891' },
                    muted: { value: '#E6ECEA' },
                },
                custard: {
                    50: { value: '#fffefa' },
                    100: { value: '#fffdf3' },
                    200: { value: '#fff9dc' },
                    300: { value: '#fff4c5' },
                    400: { value: '#ffeeaf' },
                    500: { value: '#f8e395' },
                    600: { value: '#d8c37f' },
                    700: { value: '#b7a468' },
                    800: { value: '#978452' },
                    900: { value: '#76653c' },
                    DEFAULT: { value: '#fffdf3' },
                },
                accent: {
                    50: { value: 'var(--extensions-background-light-accent)' },
                    100: { value: 'var(--extensions-background-light-accent)' },
                    200: { value: '#b3d9ff' },
                    300: { value: '#80bfff' },
                    400: { value: '#4da5ff' },
                    500: { value: 'var(--extensions-background-info)' }, // rgb(64 135 225) - синий вместо зелёного
                    600: { value: '#4087e1' },
                    700: { value: '#3065a8' },
                    800: { value: '#20436f' },
                    900: { value: '#102137' },
                    DEFAULT: { value: 'var(--extensions-background-info)' },
                    light: { value: 'var(--extensions-background-light-accent)' },
                },
                success: {
                    50: { value: 'var(--extensions-background-light-success)' },
                    100: { value: 'var(--extensions-background-light-success)' },
                    200: { value: '#b3e6b3' },
                    300: { value: '#80d180' },
                    400: { value: '#4dbc4d' },
                    500: { value: 'var(--extensions-background-success)' }, // rgb(35 178 35)
                    600: { value: '#2a8f2a' },
                    700: { value: '#1f6b1f' },
                    800: { value: '#144714' },
                    900: { value: '#0a230a' },
                    DEFAULT: { value: 'var(--extensions-background-success)' },
                    text: { value: 'var(--extensions-text-and-icon-success)' },
                    light: { value: 'var(--extensions-background-light-success)' },
                },
                error: {
                    50: { value: 'var(--extensions-background-light-error)' },
                    100: { value: 'var(--extensions-background-light-error)' },
                    200: { value: '#ffb3a3' },
                    300: { value: '#ff8066' },
                    400: { value: '#ff4d29' },
                    500: { value: 'var(--extensions-background-error)' }, // rgb(209 61 53)
                    600: { value: '#d13d35' },
                    700: { value: '#9e2e28' },
                    800: { value: '#6b1f1b' },
                    900: { value: '#38100e' },
                    DEFAULT: { value: 'var(--extensions-background-error)' },
                    text: { value: 'var(--extensions-text-and-icon-error)' },
                    light: { value: 'var(--extensions-background-light-error)' },
                },
                warning: {
                    50: { value: 'var(--extensions-background-light-warning)' },
                    100: { value: 'var(--extensions-background-light-warning)' },
                    200: { value: '#ffe6b3' },
                    300: { value: '#ffd480' },
                    400: { value: '#ffc24d' },
                    500: { value: 'var(--extensions-background-warning)' }, // rgb(255 193 60)
                    600: { value: '#cc9a4d' },
                    700: { value: '#99743a' },
                    800: { value: '#664d26' },
                    900: { value: '#332713' },
                    DEFAULT: { value: 'var(--extensions-background-warning)' },
                    text: { value: 'var(--extensions-text-and-icon-warning)' },
                    light: { value: 'var(--extensions-background-light-warning)' },
                },
                info: {
                    50: { value: 'var(--extensions-background-light-accent)' },
                    100: { value: 'var(--extensions-background-light-accent)' },
                    200: { value: '#b3d9ff' },
                    300: { value: '#80bfff' },
                    400: { value: '#4da5ff' },
                    500: { value: 'var(--extensions-background-info)' }, // rgb(64 135 225)
                    600: { value: '#4087e1' },
                    700: { value: '#3065a8' },
                    800: { value: '#20436f' },
                    900: { value: '#102137' },
                    DEFAULT: { value: 'var(--extensions-background-info)' },
                    light: { value: 'var(--extensions-background-light-accent)' },
                },
                additional: {
                    '01': { value: 'var(--additional-background-additional01)' },
                    '02': { value: 'var(--additional-background-additional02)' },
                    '03': { value: 'var(--additional-background-additional03)' },
                    splashscreen: { value: 'var(--additional-background-splashscreen)' },
                },
                overlay: {
                    dark: { value: 'var(--extensions-background-overlay-dark)' },
                    light: { value: 'var(--extensions-background-overlay-light)' },
                },
                primary: {
                    50: { value: '#f0f9ff' },
                    100: { value: '#e0f2fe' },
                    200: { value: '#bae6fd' },
                    300: { value: '#7dd3fc' },
                    400: { value: '#38bdf8' },
                    500: { value: 'var(--background-brand)' },
                    600: { value: 'var(--background-brand-pressed)' },
                    700: { value: '#0369a1' },
                    800: { value: '#075985' },
                    900: { value: '#0c4a6e' },
                },
                mistySage: {
                    50: { value: '#f6f8f7' },
                    100: { value: '#F4F8F9' },
                    200: { value: '#d9e2df' },
                    300: { value: '#4E9AAA' },
                    400: { value: '#5E8B99' },
                    500: { value: '#428696' },
                    600: { value: '#3E7A88' },
                    700: { value: '#2E5B66' },
                    800: { value: '#1E3C44' },
                    900: { value: '#0E1E22' },
                },
                whiteAlpha: {
                    0: { value: '#FFFFFF' },
                },
                service: {
                    badge: { value: '#E5F3F6' },
                    timeBadge: { value: '#F2EEDC' },
                },
                activeCard: {
                    value: '#E6F0F3',
                },
            },
            shadows: {
                card: {
                    value: '0px 0px 1px 0px rgba(24,24,27,0.3), 0px 8px 16px 0px rgba(24,24,27,0.1)',
                },
            },
            fonts: {
                body: { value: 'Inter, var(--font-family-noto), system-ui, sans-serif' },
                heading: { value: 'Inter, var(--font-family-noto), system-ui, sans-serif' },
                mono: { value: 'monospace' },
            },
            fontSizes: {
                heading: { value: '40px' },
            },

            radii: {
                sm: { value: '8px' },
                md: { value: '16px' },
                lg: { value: '24px' },
                xl: { value: '32px' },
                full: { value: '9999px' },
            },
            borders: {
                card: { value: '2px solid' },
            },
        },
        semanticTokens: {
            colors: {
                brand: {
                    solid: { value: '{colors.brand.500}' },
                    contrast: { value: '{colors.custard.50}' },
                    fg: { value: { _light: '{colors.brand.700}', _dark: '{colors.brand.300}' } },
                    muted: { value: '{colors.brand.100}' },
                    subtle: { value: '{colors.brand.200}' },
                    emphasized: { value: '{colors.brand.300}' },
                    focusRing: { value: '{colors.brand.500}' },
                },
                sage: {
                    solid: { value: '#6DA293' },
                    contrast: { value: '{colors.sage.50}' },
                    fg: { value: { _light: '{#314E49}', _dark: '{colors.sage.300}' } },
                    muted: { value: '#E6ECEA' },
                    subtle: { value: '{colors.sage.200}' },
                    emphasized: { value: '{colors.sage.300}' },
                    focusRing: { value: '{colors.sage.500}' },
                },
                page: {
                    canvas: {
                        value: { _light: '{colors.custard.100}', _dark: '{colors.gray.950}' },
                    },
                    surface: {
                        value: { _light: '{colors.custard.50}', _dark: '{colors.gray.900}' },
                    },
                },
                mistySage: {
                    solid: { value: '{colors.mistySage.500}' },
                    contrast: { value: '{colors.mistySage.100}' },
                    fg: { value: '{colors.mistySage.100}' },
                    muted: { value: '{colors.mistySage.300}' },
                    subtle: { value: '{colors.mistySage.200}' },
                    emphasized: { value: '{colors.mistySage.300}' },
                    focusRing: { value: '{colors.mistySage.500}' },
                },
                bg: {
                    default: { value: '#FFFFFF' },
                    muted: { value: '#E4E4E7' },
                    subtle: { value: '#F4F4F5' },
                },
                text: {
                    fg_muted: { value: '#52525B' },
                    fg: { value: '#212121' },
                    fg_inverted: { value: '#FAFAFA' },
                    fg_sub: { value: '#71717a' },
                },
                fg: {
                    subtle: { value: '#A1A1AA' },
                },
            },
            lineHeights: {
                tall: { value: '20px' },
            },
        },
    },
})

export const customSystem = createSystem(defaultConfig, customConfig)
